import TurndownService from 'turndown';
import { marked } from 'marked';

const renderer = new marked.Renderer();
const turndownService = new TurndownService();
renderer.link = (href, _, text) => {
  const target = href.startsWith("http") ? "_blank" : "";
  return target ? `<a href="${href}" target="${target}" rel="noopener noreferrer">${text}</a>` : `<a href="${href}">${text}</a>`;
};
turndownService.addRule("strikethrough", {
  filter: ["del", "s"],
  replacement(content) {
    return `~~${content}~~`;
  }
});
turndownService.addRule("heading", {
  filter: ["h1", "h2", "h3", "h4", "h5", "h6"],
  replacement(content, node) {
    const level = Number(node.nodeName.charAt(1));
    return `${"#".repeat(level === 1 ? 2 : level)} ${content}`;
  }
});
const stripHtml = (html) => String(html).replace(/<[^>]*>?/gm, "");
const toHTML = (content, { inline } = {}) => {
  return marked[inline ? "parseInline" : "parse"](content || "", { headerIds: false, renderer });
};
const toMarkdown = (content) => {
  return turndownService.turndown(content || "");
};
const toRaw = (content) => {
  return stripHtml(toHTML(content));
};

export { stripHtml, toHTML, toMarkdown, toRaw };
